export type ChartColor = 'default' | 'warn';
export const chartBackgroundTransparencyLevel = '22';

export const colors = new Map<ChartColor, string>();
colors.set('default', '#36a2eb');
colors.set('warn', '#eb366c');
